const r = {
  page404: {
    title: "crwdns158953:0crwdne158953:0",
    message: "crwdns158955:0crwdne158955:0",
    action_btn: "crwdns158957:0crwdne158957:0"
  },
  address: {
    title: "crwdns291071:0crwdne291071:0",
    type: {
      personal: "crwdns158959:0crwdne158959:0",
      company: "crwdns158961:0crwdne158961:0"
    },
    organisation: {
      label: "crwdns158963:0crwdne158963:0"
    },
    name: {
      label: "crwdns158965:0crwdne158965:0"
    },
    contact_person: {
      label: "crwdns158967:0crwdne158967:0"
    },
    street: {
      label: "crwdns158969:0crwdne158969:0",
      address1: "crwdns158971:0crwdne158971:0",
      address2: "crwdns158973:0crwdne158973:0"
    },
    city: {
      label: "crwdns158975:0crwdne158975:0"
    },
    postal_code: {
      label: "crwdns158977:0crwdne158977:0"
    },
    country_code: {
      label: "crwdns158979:0crwdne158979:0"
    },
    company_data: {
      title: "crwdns158981:0crwdne158981:0"
    },
    company_id: {
      label: "crwdns158983:0crwdne158983:0"
    },
    tax_id: {
      label: "crwdns158985:0crwdne158985:0"
    },
    vat_id: {
      label: "crwdns158987:0crwdne158987:0"
    }
  },
  profile: {
    emails: {
      label: "crwdns158989:0crwdne158989:0"
    },
    email: {
      label: "crwdns158991:0crwdne158991:0"
    },
    phone: {
      label: "crwdns158993:0crwdne158993:0",
      short: "crwdns291073:0crwdne291073:0"
    }
  },
  validation: {
    country_required: "crwdns158995:0crwdne158995:0",
    company_id: {
      not_valid: "crwdns158997:0crwdne158997:0"
    },
    tax_id: {
      not_valid: "crwdns158999:0crwdne158999:0"
    },
    vat_id: {
      not_valid: "crwdns159001:0crwdne159001:0"
    }
  },
  general: {
    back: "crwdns159003:0crwdne159003:0",
    cancel: "crwdns159005:0crwdne159005:0",
    close: "crwdns159007:0crwdne159007:0",
    remove: "crwdns427944:0crwdne427944:0",
    optional: "crwdns159009:0crwdne159009:0",
    period: {
      months: "crwdns159011:0period={period}crwdne159011:0",
      years: "crwdns159013:0period={period}crwdne159013:0",
      explicit: "crwdns159015:0crwdne159015:0",
      short: {
        months: "crwdns247227:0period={period}crwdne247227:0",
        years: "crwdns247229:0period={period}crwdne247229:0"
      },
      next: {
        months: "crwdns247223:0period={period}crwdne247223:0",
        years: "crwdns247225:0period={period}crwdne247225:0",
        short: {
          months: "crwdns247231:0period={period}crwdne247231:0",
          years: "crwdns247233:0period={period}crwdne247233:0"
        }
      },
      per: {
        months: "crwdns357198:0period={period}crwdne357198:0",
        years: "crwdns357200:0period={period}crwdne357200:0",
        short: {
          months: "crwdns357202:0period={period}crwdne357202:0",
          years: "crwdns357204:0period={period}crwdne357204:0"
        }
      }
    },
    or: "crwdns159017:0crwdne159017:0",
    recommended: "crwdns159019:0crwdne159019:0",
    settings: "crwdns159021:0crwdne159021:0",
    edit: "crwdns159023:0crwdne159023:0",
    save: "crwdns159025:0crwdne159025:0",
    save_changes: "crwdns159027:0crwdne159027:0",
    reset_form: "crwdns159029:0crwdne159029:0",
    not_available: "crwdns159031:0crwdne159031:0",
    unknown_error: "crwdns159033:0crwdne159033:0",
    unknown_error_id: "crwdns159035:0{id}crwdne159035:0",
    something_went_wrong: "crwdns159037:0crwdne159037:0",
    link: "crwdns159039:0crwdne159039:0",
    buy: "crwdns427946:0crwdne427946:0"
  },
  capslock_hint: {
    line1: "crwdns159041:0crwdne159041:0",
    line2: "crwdns159043:0crwdne159043:0"
  },
  ws_places_input: {
    no_results: "crwdns159045:0crwdne159045:0"
  },
  ws_uploader: {
    validation: {
      file_type: "crwdns159047:0crwdne159047:0",
      file_size: "crwdns159049:0{limit}crwdne159049:0"
    },
    status: {
      label: "crwdns159051:0crwdne159051:0",
      value: {
        uploaded: "crwdns159053:0crwdne159053:0",
        uploading: "crwdns159055:0crwdne159055:0",
        failed: "crwdns159057:0crwdne159057:0",
        idle: "crwdns324040:0crwdne324040:0"
      }
    },
    action: {
      title: "crwdns159059:0crwdne159059:0",
      text1: "crwdns159061:0crwdne159061:0",
      link: "crwdns159063:0crwdne159063:0",
      text2: "crwdns159065:0crwdne159065:0",
      abort_tooltip: "crwdns159067:0crwdne159067:0"
    },
    remove_btn: "crwdns159069:0crwdne159069:0"
  },
  ws_table: {
    filter: {
      fulltext_title: "crwdns159071:0crwdne159071:0",
      data_title: "crwdns159073:0crwdne159073:0",
      clear_filters: "crwdns159075:0crwdne159075:0",
      from: "crwdns416888:0crwdne416888:0",
      to: "crwdns416890:0crwdne416890:0"
    },
    label: {
      selected: "crwdns159077:0crwdne159077:0",
      filterby: "crwdns159079:0crwdne159079:0"
    }
  },
  ws_password_strength: {
    rule1: "crwdns159081:0crwdne159081:0",
    rule2: "crwdns159083:0crwdne159083:0",
    rule3: "crwdns159085:0crwdne159085:0",
    rule4: "crwdns159087:0crwdne159087:0"
  },
  copy: {
    copy: "crwdns159089:0crwdne159089:0",
    copied: "crwdns159091:0crwdne159091:0",
    saved_in_clipboard: "crwdns159093:0crwdne159093:0"
  },
  out_modal: {
    title: "crwdns159095:0crwdne159095:0",
    text: "crwdns159097:0crwdne159097:0",
    delimiter_text: "crwdns159099:0crwdne159099:0"
  }
}, d = {
  wsk: r
};
export {
  d as default,
  r as wsk
};
//# sourceMappingURL=wsk.xx-XX-3730ab49.js.map
